import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {YesNoModal} from "./YesNoModal";
import {URL_INDICATOR} from "../dashboard/columns";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {getAlertSnoozePeriodDataByPeriod} from "../../periods";

export const DATA_BY_INDICATOR = {[URL_INDICATOR]: {"question": `Si confirma la operación no se estarán enviando alertas por email y tampoco al webhook en caso de que la URL no funcione (o vuelva a funcionar) por el período de tiempo seleccionado.`}};

class AlertSnoozeWithOptionsInput extends Component {
    constructor(props) {
        super(props);
        this.handleConfirmation = this.handleConfirmation.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleNoAnswer = this.handleNoAnswer.bind(this);
        this.handlerActivateNotification = this.handlerActivateNotification.bind(this)

        this.state = {
            periodSelected: null,
            confirmingSnooze: false,
            isSnoozed: this.props.isSnoozed,
            snoozedUntil: this.props.snoozedUntil
        };
    }

    handlerActivateNotification(event) {
        event.preventDefault();

        const snoozeData = {
            "indicator": this.props.indicator,
            "sub_indicator": this.props.subIndicator
        };

        new APIClient(API_URL + 'alert-snooze').call('DELETE', snoozeData)
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                    this.setState({
                        periodSelected: null,
                        isSnoozed:false
                    });
                }
            })
            .catch((error) => {
                // Handle the 405 Method Not Allowed (or any other fetch error) here
                console.error(error);
                alert("Error: " + error.message);
            });

    }

    handleSelectChange(event) {
        const period = event.target.value;
        this.setState({
            periodSelected: period,
            confirmingSnooze: true
        });
    }

    handleNoAnswer() {
        this.setState({
            periodSelected: null,
            confirmingSnooze: false
        });
    }

    handleConfirmation() {
        const snoozeData = {
            "indicator": this.props.indicator,
            "sub_indicator": this.props.subIndicator,
            "period": this.state.periodSelected
        };

        new APIClient(API_URL + 'alert-snooze').call('POST', snoozeData)
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                    this.setState({
                        confirmingSnooze: false,
                        snoozedUntil: responseData.data["snoozed_until"],
                        isSnoozed: true
                    });

                    if(this.props.onSnooze !== undefined) {
                        this.props.onSnooze(responseData.data);
                    }
                }
            })
            .catch((error) => {
            // Handle the 405 Method Not Allowed (or any other fetch error) here
            console.error(error);
            alert("Error: " + error.message);
        });
    }

    getQuestion() {
        return DATA_BY_INDICATOR[this.props.indicator]["question"];
    }

    render() {
        const {t} = this.props;
        if (this.state.isSnoozed === true){
            if(this.state.snoozedUntil != null){
                return <span>Silenciado hasta {this.state.snoozedUntil}<br/><span className="activate_alert"><a href="#" onClick={this.handlerActivateNotification}>Activar alerta</a></span></span>
            }else {
                return <span>Silenciado para siempre<br/><span className="activate_alert"><a href="#" onClick={this.handlerActivateNotification}>Activar alerta</a></span></span>
            }
        }

        return [
            <select name={this.props.name}
                    onChange={this.handleSelectChange}
                    value=""
                    disabled={this.props.disabled}
                    className="snooze_alert_select">
                <option className="select-empty-item" key='empty-option' value="">Notificación activada</option>
                {Object.keys(getAlertSnoozePeriodDataByPeriod(t)).map((period) => (
                    <option key={period}
                            value={period}>{getAlertSnoozePeriodDataByPeriod(t)[period]["silenceFor"]}</option>
                ))}
            </select>,
            <YesNoModal onYesAnswer={this.handleConfirmation}
                        title="Desactivar la notificación por email y webook"
                        message={this.getQuestion()}
                        question="¿Desea continuar?"
                        skipRenderButton={true}
                        isOpen={this.state.confirmingSnooze}
                        onNoAnswer={this.handleNoAnswer}
            />
        ];
    }
}

export default withTranslation()(AlertSnoozeWithOptionsInput);
